<app-alert></app-alert>
<app-loader></app-loader>
<router-outlet></router-outlet>
